import { useEffect, useState } from 'react';

export default function FadeIn(props) {
  const [visible, setVisible] = useState(false);

  useEffect(function() {
    var timer = setTimeout(function() { setVisible(true); }, props.delay || 0);
    return function() { clearTimeout(timer); };
  }, [props.delay]);

  return (
    <div style={{
      opacity: visible ? 1 : 0,
      transform: visible ? 'translateY(0)' : 'translateY(8px)',
      transition: 'opacity 0.4s ease, transform 0.4s ease',
    }}>
      {props.children}
    </div>
  );
}